import(/* webpackMode: "eager", webpackExports: ["LazySection"] */ "/home/runner/work/settlin.in/settlin.in/components/common/lazy-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyOverlay"] */ "/home/runner/work/settlin.in/settlin.in/components/common/property-overlay/property-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/settlin.in/settlin.in/components/customer-care-widget/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuyerPropertiesInitializer"] */ "/home/runner/work/settlin.in/settlin.in/components/global/buyer-properties-initializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbySUPsClient"] */ "/home/runner/work/settlin.in/settlin.in/components/nearby-sups/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyNearbyPlacesMap"] */ "/home/runner/work/settlin.in/settlin.in/components/project-or-sup/lazy-nearby-places-map.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AvailableSUPs"] */ "/home/runner/work/settlin.in/settlin.in/components/projects/available-sups.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectPageTracking"] */ "/home/runner/work/settlin.in/settlin.in/components/projects/project-page-tracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbySupsSkeleton"] */ "/home/runner/work/settlin.in/settlin.in/components/projects/skeletons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectTitle"] */ "/home/runner/work/settlin.in/settlin.in/components/projects/title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromotionalCardsSection"] */ "/home/runner/work/settlin.in/settlin.in/components/promotional-cards/hooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/settlin.in/settlin.in/components/replace-url.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SEOContentSetter"] */ "/home/runner/work/settlin.in/settlin.in/components/seo-content-setter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdditionalFeatures"] */ "/home/runner/work/settlin.in/settlin.in/components/sup/additional-features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsWrapper"] */ "/home/runner/work/settlin.in/settlin.in/components/sup/breadcrumbs-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GalleryLarge"] */ "/home/runner/work/settlin.in/settlin.in/components/sup/gallery/large.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GallerySmall"] */ "/home/runner/work/settlin.in/settlin.in/components/sup/gallery/small.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AmenitiesSection"] */ "/home/runner/work/settlin.in/settlin.in/components/sup/sections/amenities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectDetails"] */ "/home/runner/work/settlin.in/settlin.in/components/sup/sections/project-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SEOContentForProjectOrSup"] */ "/home/runner/work/settlin.in/settlin.in/components/sup/seo/content-project-sup.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/settlin.in/settlin.in/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/script.js");
